import { Card, Form, Row } from "antd";

import CommonButton from "../../Component/CommonButton";
import CommonInput from "../../Component/CommonInput";
import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";
import React from "react";
import _ from "lodash";
import { handleErrorMessage } from "../../utils/helper/common";
import { history } from "../../App";
import { router } from "../../constants/constans";
import { signin } from "../../api/authentication";
import styles from "./style.module.scss";
import { useMutation } from "react-query";
import useNetworkStatus from "../../hooks/useNetworkStatus";
import { useRulesForm } from "../../hooks/useRulesForm";
import { useTranslation } from "react-i18next";

export default function Login() {
  const { rulesForm } = useRulesForm();
  const { t } = useTranslation();
  const isOnline = useNetworkStatus();

  const loginMutation = useMutation({
    mutationFn: (values: { username: string; password: string }) =>
      signin(values),
  });

  const handleSubmit = async (payload: any) => {
    const params = _.pick(payload, ["username", "password"]);
    if (!isOnline) {
      const savedUsername = Cookies.get("usernameRemember");
      if (savedUsername && params?.username === savedUsername) {
        Cookies.set("notSync", "1");
        Cookies.set("token", "accessToken", {});
        history.push(router.Home.Origin);
      }
    } else {
      loginMutation.mutate(params, {
        onSuccess: (data) => {
          const { accessToken, refreshToken, plan } = data.data;
          const now = new Date();
          const jstNow = new Date(
            now.toLocaleString("en-US", { timeZone: "Asia/Tokyo" })
          );

          const expiresAtNoonJST = new Date(jstNow);
          expiresAtNoonJST.setHours(12, 0, 0, 0);

          if (jstNow.getHours() >= 12) {
            expiresAtNoonJST.setDate(expiresAtNoonJST.getDate() + 1);
          }

          Cookies.set("token", accessToken, {
            expires: expiresAtNoonJST,
          });
          Cookies.set("refreshToken", refreshToken, {
            expires: expiresAtNoonJST,
          });

          Cookies.set("userPlan", plan, {
            expires: expiresAtNoonJST,
          });
          Cookies.set("usernameRemember", params.username);
          history.push(router.Home.Origin);
        },
        onError: (error) => {
          handleErrorMessage(error);
        },
      });
    }
  };

  const isAuthenticated = !!Cookies.get("token");
  if (isAuthenticated) return <Navigate to="/" />;

  return (
    <div className={styles.loginContainer}>
      <div className={styles.headerContainer}>
        <div className={styles.titleHeader}>初回付け回し管理アプリ</div>
        <div className={styles.titleHeaderBold}>内勤革命</div>
      </div>
      <Card bordered className={styles.loginForm}>
        <Form onFinish={handleSubmit} layout="vertical">
          <Form.Item
            label={<span className="labelFormItem">ユーザー名</span>}
            name="username"
            rules={[
              rulesForm("ユーザー名").required,
              rulesForm("ユーザー名").max(255),
            ]}
            labelAlign="left"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
          >
            <CommonInput maxLength={255} placeholder="ユーザー名" />
          </Form.Item>
          <Form.Item
            label={<span className="labelFormItem">パスワード</span>}
            name="password"
            rules={[
              rulesForm("パスワード").required,
              rulesForm("パスワード").min(8),
              rulesForm("パスワード").max(32),
            ]}
            labelAlign="left"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
          >
            <CommonInput isPassword={true} placeholder="パスワード" />
          </Form.Item>
          <Form.Item labelCol={{ span: 24 }}>
            <Row justify="center">
              <CommonButton
                className={styles.btnSubmit}
                text={t("common.signin")}
                disabled={loginMutation.isLoading}
              />
            </Row>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
